import InvoiceBuilder from "./invoice-builder";

// Settings > Invoice Builder (replaces the old grid based table editor).
function InvoiceCustomization() {
  return <InvoiceBuilder />;
}

export default InvoiceCustomization;
